import React from 'react';
import PropTypes from 'prop-types';
import { get, maxBy } from 'lodash';
import numeral from 'numeral';
import moment from 'moment';
import { css, cx } from '@bd/bdui-styles/emotion';
import { Image, GoogleMapUrl } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
import withData from '@bd/bdcore-data';
import { ActivateMapPin } from '@bd/bdcore-data/build/Map';
import LightBox from '@bd/bdui-lightbox';
import { FavoriteToggle } from './Favorites';
import CompareButton from './CompareButton';
import { colors } from '../styles';
import ScheduleModal from '../components/ScheduleModal';
// import ScheduleTagDesktop from '../components/Header/ScheduleTagDesktop';

const styles = css`
  width: calc(100vw - 60px);
  max-width: 375px;
  margin: 0 15px 30px 15px;
  .HomeCard_wrapper {
    display: flex;
    @media (min-width: 992px) {
      &:hover {
        .HomeCard_media {
          box-shadow: 0 10px 15px 0 rgba(0,0,0,0.15);
        }
      }
    }
    a {
      color: ${colors.body};
    }
  }
  .HomeCard_inner {
    width: 100%;
    position: relative;
  }
  .HomeCard_media {
    position: relative;
    transition: all .3s ease;
    border: 10px solid ${colors.white};
    overflow: hidden;
    a {
      display: block;
    }
  }
  .HomeCard_image {
    width: 100%;
    height: auto;
  }
  .HomeCard_content {
    padding: 10px 0 0 0;
    position: relative;
  }
  .HomeCard_priceValue {
    font-size: 21px;
    font-weight: 700;
    line-height: 1;
    margin: 0;
    color: ${colors.body};
    vertical-align: middle;
    @media (min-width: 480px) {
      font-size: 24px;
    }
  }
  .HomeCard_status {
    font-size: 14px;
    line-height: 1;
    font-weight: 400;
    border-left: 1px solid ${colors.gray};
    margin: 0 0 0 10px;
    padding: 0 0 0 10px;
    display: inline-block;
    vertical-align: middle;
    @media (min-width: 992px) {
      font-size: 15px;
    }
  }
  .HomeCard_address {
    margin: 4px 0 0 0;
    font-size: 15px;
    line-height: 1;
    font-weight: 400;
    color: ${colors.body};
    a {
      color: ${colors.body};
    }
  }
  .HomeCard_city {
    margin: 0 0 0 0;
    font-size: 15px;
    font-weight: 400;
    color: ${colors.body};
    a {
      color: ${colors.body};
    }
  }
  .HomeCard_iconList {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .HomeCard_iconListItem {
    text-align: center;
    font-size: 15px;
    line-height: 1;
    font-weight: 400;
    margin: 0 10px 0 0;
    &:not(:last-child) {
      padding: 0 10px 0 0;
      border-right: 1px solid ${colors.gray};
    }
  }
  .HomeCard_iconListIcon {
    margin: 0 0 4px 0;
    display: none;
  }
  .HomeCard_iconListValue {
    font-weight: 700;
    margin: 0 3px 0 0;
  }
  .HomeCard_linkIcon {
    width: 13px;
    height: 13px;
    margin: 5px 0 0 0;
    display: none;
  }
  .HomeCard_mapButtonWrapper {
    width: 23px;
    height: 31px;
    position: absolute;
    top: 15px;
    right: 15px;
    display: none;
  }
  .HomeCard_mapButton {
    width: 23px;
    height: 31px;
    background-image: url('/images/icon-map-pin-brand2.svg');
    background-position: center center;
    background-repeat: no-repeat;
  }
  .HomeCard_detailButton_wrapper {
    position: absolute !important;
    width: 55px;
    overflow: hidden;
    height: 45px;
    right: 0;
    bottom: 0;
    transition: all .3s ease;
    &:hover {
      width: 125px;
      height: 105px;
      transition: all .3s ease;
    }
  }
  .HomeCard_detailButton {
    height: 45px;
    width: 45px;
    position: absolute;
    right: 10px;
    bottom: 0px;
    z-index: 2;
    transition: all .3s ease;
    overflow: visible;
    transform-origin: bottom right;
    transform: rotate(-45deg);
    &::before {
      content: '';
      position: absolute;
      top: 19px;
      left: 38px;
      width: 16px;
      height: 16px;
      background-image: url('/images/icon-plus.svg');
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
      transition: all .3s ease;
      z-index: 2;
      opacity: 1;
      transform: rotate(-45deg);
    }
    &::after {
      content: '';
      height: 90px;
      width: 90px;
      background-color: ${colors.white};
      background-image: none;
      border-radius: 50%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      transition: all .3s ease;
      z-index: 1;
    }
    &:focus {
      outline: none;
    }
    &:hover {
      height: 110px;
      width: 110px;
      transform: rotate(0deg);
      &::before {
        transform: rotate(45deg);
        top: 90px;
        left: 90px;
      }
      &::after {
        top: 55px;
        left: 55px;
        width: 120px;
        height: 120px;
      }
      .HomeCard_detailButtonIcon1 {
        top: 8px;
        left: 65px;
        opacity: 1;
      }
      .HomeCard_detailButtonIcon2 {
        top: 30px;
        left: 28px;
        opacity: 1;
      }
      .HomeCard_detailButtonIcon3 {
        top: 67px;
        left: 8px;
        opacity: 1;
      }
    }
  }
  .HomeCard_detailButton_active {
    height: 110px;
    width: 110px;
    transform: rotate(0deg);
    &::before {
      transform: rotate(45deg);
      top: 90px;
      left: 90px;
    }
    &::after {
      top: 55px;
      left: 55px;
      width: 120px;
      height: 120px;
    }
    .HomeCard_detailButtonIcon1 {
      top: 8px;
      left: 65px;
      opacity: 1;
    }
    .HomeCard_detailButtonIcon2 {
      top: 30px;
      left: 28px;
      opacity: 1;
    }
    .HomeCard_detailButtonIcon3 {
      top: 67px;
      left: 8px;
      opacity: 1;
    }
  }
  .HomeCard_detailButtonIcon1 {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    position: absolute;
    top: -40px;
    left: -40px;
    background-color: ${colors.brand1};
    border: 4px solid ${colors.white};
    transition: all .3s ease;
    opacity: 0;
    background-image: url('/images/icon-calendar-white.svg');
    background-position: center center;
    background-size: 17px 18px;
    background-repeat: no-repeat;
  }
  .HomeCard_detailButtonIcon2 {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    position: absolute;
    top: -40px;
    left: -40px;
    background-color: ${colors.white};
    transition: all .3s ease;
    opacity: 0;
    background-image: url('/images/icon-360-blue-circle.svg');
    background-position: center center;
    background-size: 30px 30px;
    background-repeat: no-repeat;
  }
  .HomeCard_detailButtonIcon3 {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    position: absolute;
    top: -40px;
    left: -40px;
    background-color: ${colors.white};
    transition: all .3s ease;
    opacity: 0;
    background-image: url('/images/icon-camera-blue-circle.svg');
    background-position: center center;
    background-size: 30px 30px;
    background-repeat: no-repeat;
  }
  .HomeCard_detailButton-disabled {
    pointer-events: none;
    opacity: .8 !important;
    filter: saturate(0);
  }
  .HomeCard_list1 {
    list-style: none;
    margin: 0 -20px;
    border-top: 1px solid ${colors.neutral};
    border-bottom: 1px solid ${colors.neutral};
    padding: 10px 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .HomeCard_list2 {
    list-style: none;
    margin: 10px 0;
    padding: 0;
  }
  .HomeCard_list2Item {
    font-size: 14px;
    line-height: 1;
    flex: 1;
    padding: 0 0 0 0;
    &:not(:last-child) {
      padding: 0 0 5px 0;
    }
    a {
      font-weight: 700;
      color: ${colors.brand1};
    }
    @media (min-width: 992px) {
      font-size: 15px;
    }
  }
  .HomeCard_openHouseBanner {
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
    &::before {
      content: '';
      position: absolute;
      z-index: 1;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: ${colors.white};
      opacity: .8;
    }
  }
  .HomeCard_openHouseBannerContent {
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1;
    font-weight: 700;
    position: relative;
    z-index: 2;
  }
  .HomeCard_headlineBanner {
    position: absolute;
    left: 0;
    bottom: 0;
    pointer-events: none;
    max-width: calc(100% - 70px);
    &::before {
      content: '';
      position: absolute;
      z-index: 1;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: ${colors.body};
      opacity: .8;
    }
  }
  .HomeCard_headlineBannerContent {
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1;
    font-weight: 700;
    position: relative;
    z-index: 2;
    color: ${colors.body}
  }
  .sold {
    color: ${colors.brand3};
    text-transform:uppercase;
  }
`;

const videoBoxStyle = css`
  position: relative;
  width: 80vw;
  height: 80vh;
  margin: 10vh 10vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;

class HomeCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cornerIsOpen: false,
    };
    this.openCorner = this.openCorner.bind(this);
    this.closeCorner = this.closeCorner.bind(this);
    window.addEventListener('message', event => {
      if (typeof event.data === 'string' && event.data.match(/scheduler:close/)) {
        this.closeCorner();
      }
    });
  }

  openCorner(e) {
    if (this.state.cornerIsOpen === false) {
      e.preventDefault();
      this.setState({
        cornerIsOpen: true,
      });
    }
  }

  closeCorner(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ cornerIsOpen: false });
  }

  render() {
    const { home, plan, community, nextOpenHouse, hideCommunity,
    hideFloorplan, hideLot, className } = this.props;

    let dateStatus;
    if (moment().isBefore(moment(get(home, 'moveInDate')))) {
      dateStatus = `Ready ${moment(get(home, 'moveInDate')).format('MMMM D, YYYY')}`;
    } else {
      dateStatus = 'Available Today';
    }

    const displayOpenHouse = nextOpenHouse || get(home, 'openHouses', [])
    .filter(oH => moment(oH.date_localDate).isSameOrAfter(moment(), 'day'))
    .reduce((nearest, oH) => {
      const diff = moment(oH.date_localDate).diff(moment(), 'days');
      if (diff < nearest.diff) {
        return {
          ...oH,
          diff,
        };
      }

      return nearest;
    }, { diff: Infinity });
    return (
      <div className={cx(styles, className)}>
        <ActivateMapPin hover itemId={get(home, '_id')}>
          <div className="HomeCard_wrapper">
            <div className="HomeCard_inner">
              <div className="HomeCard_media">
                <Link name="home-detail" home={home}>
                  <Image
                    className="HomeCard_image"
                    src={get(home, 'elevationPhotos[0].contentUrl', get(home, 'photos[0].contentUrl', '/images/home-default-image.jpg'))}
                    alt={get(home, 'photos[0].name', get(home, 'photos[0].caption', get(home, 'elevationPhotos[0].name', '')))}
                    width={600}
                    height={380}
                    exact
                    applySize
                  />
                </Link>
                <FavoriteToggle home={home} />
                {
                  get(home, 'openHouses').length > 0 &&
                  moment(maxBy(home.openHouses, 'date_localDate').date_localDate).isSameOrAfter(moment(), 'day') &&
                  <div className="HomeCard_openHouseBanner">
                    <div className="HomeCard_openHouseBannerContent">
                      <strong>Open House: </strong>
                      {`${moment(get(displayOpenHouse, 'date_localDate')).format('ddd MM/DD')}, `}
                      {`${moment(`${get(displayOpenHouse, 'date_localDate')}T${get(displayOpenHouse, 'startTime_localTime')}`).format('h:mm a')} - `}
                      {`${moment(`${get(displayOpenHouse, 'date_localDate')}T${get(displayOpenHouse, 'endTime_localTime')}`).format('h:mm a')}`}
                    </div>
                  </div>
                }
                {
                  get(home, 'headline') &&
                  <div className="HomeCard_headlineBanner">
                    <div className="HomeCard_headlineBannerContent">
                      {get(home, 'headline')}
                    </div>
                  </div>
                }
                <div className="HomeCard_detailButton_wrapper">
                  <div className="HomeCard_detailButton" role="button" tabIndex="0" onClick={this.openCorner}>
                    {
                      community &&
                      get(community, 'schedule_appointment_link') &&
                      <ScheduleModal community={community}>
                        <div className="HomeCard_detailButtonIcon1" title="Schedule Appointment" />
                      </ScheduleModal>
                    }
                    {
                      (!community || !get(community, 'schedule_appointment_link')) &&
                      <Link name="schedule-appointment">
                        <div className="HomeCard_detailButtonIcon1" title="Schedule Appointment" />
                      </Link>
                    }
                    <LightBox
                      items={[{
                        element: (
                          <div className={videoBoxStyle}>
                            <div className="embed-responsive embed-responsive-16by9 mx-auto">
                              <iframe title="Tour" src={get(home, 'tourUrl') || get(plan, '3d_tour') || get(plan, 'tourUrl')} frameBorder="0" allowFullScreen />
                            </div>
                          </div>
                        ) }]
                      }
                      enableZoom
                    >
                      <div className={`HomeCard_detailButtonIcon2 ${!get(home, 'tourUrl') && !get(plan, 'tourUrl') && !get(plan, '3d_tour') ? 'HomeCard_detailButton-disabled' : ''}`} title="Virtual Tour" />
                    </LightBox>
                    <LightBox items={get(home, 'photos')} enableZoom>
                      <div className="HomeCard_detailButtonIcon3" title="Photo Gallery" />
                    </LightBox>
                  </div>
                </div>
              </div>
              <div className="HomeCard_content">
                <div>
                  {
                    get(home, 'price') > 0 &&
                    <span className="HomeCard_priceValue">{numeral(get(home, 'price')).format('$0,0')}</span>
                  }
                  {
                    get(home, 'moveInDate') && dateStatus &&
                    <span className="HomeCard_status">
                      {
                        <span>{dateStatus}</span>
                      }
                    </span>
                  }
                  {
                    get(home, 'lot') &&
                    !hideLot &&
                    <span className="HomeCard_status">
                      Homesite {get(home, 'lot')}
                    </span>
                  }
                </div>
                <h4 className="HomeCard_address">
                  <Link name="home-detail" home={home}>
                    {get(home, 'address.streetAddress')}, <span className="HomeCard_city">{get(home, 'address.addressLocality')}, {get(home, 'address.addressRegion')}</span>
                  </Link>
                </h4>
                <a href={GoogleMapUrl(home)} className="HomeCard_mapButtonWrapper" target="_blank" rel="noopener noreferrer" title={home.name}>
                  <div className="HomeCard_mapButton" title="Map This Home" />
                </a>
                <ul className="HomeCard_list2">
                  {
                    get(community, 'name') &&
                    !hideCommunity &&
                    <li className="HomeCard_list2Item">
                      Community: <Link name="community-detail" community={community}>{get(community, 'name')}</Link>
                    </li>
                  }
                  {
                    get(plan, 'name') &&
                    !hideFloorplan &&
                    <li className="HomeCard_list2Item">
                      Floor Plan: <Link name="plan-detail" plan={plan} community={community}>{get(plan, 'name')}</Link>
                    </li>
                  }
                </ul>
                <ul className="HomeCard_iconList">
                  {
                    !!get(home, 'beds') &&
                    <li className="HomeCard_iconListItem">
                      <span className="HomeCard_iconListIcon"><img src="/images/icon-beds.svg" alt="" /></span>
                      <span className="HomeCard_iconListValue">{get(home, 'beds')}</span>
                      <span className="HomeCard_iconListLabel">Beds</span>
                    </li>
                  }
                  {
                    !!get(home, 'bathsFull') &&
                    <li className="HomeCard_iconListItem">
                      <span className="HomeCard_iconListIcon"><img src="/images/icon-baths.svg" alt="" /></span>
                      <span className="HomeCard_iconListValue">
                        {get(home, 'bathsFull')} {get(home, 'bathsHalf', 0) > 0 && '.5'}
                      </span>
                      <span className="HomeCard_iconListLabel">Baths</span>
                    </li>
                  }
                  {
                    !!get(home, 'sqft') &&
                    <li className="HomeCard_iconListItem">
                      <span className="HomeCard_iconListIcon"><img src="/images/icon-sqft.svg" alt="" /></span>
                      <span className="HomeCard_iconListValue">{numeral(get(home, 'sqft')).format('0,0')}</span>
                      <span className="HomeCard_iconListLabel">SQ FT</span>
                    </li>
                  }
                </ul>
                <CompareButton
                  limit={5}
                  className="CommunityListCard_btnCompare"
                  type="homes"
                  id={home._id}
                />
              </div>
            </div>
          </div>
        </ActivateMapPin>
      </div>
    );
  }
}

HomeCard.propTypes = {
  home: PropTypes.object.isRequired,
  plan: PropTypes.object,
  community: PropTypes.object,
  nextOpenHouse: PropTypes.object,
  hideCommunity: PropTypes.bool,
  hideFloorplan: PropTypes.bool,
  hideLot: PropTypes.bool,
  className: PropTypes.string,
};

HomeCard.defaultProps = {
  plan: undefined,
  community: undefined,
  nextOpenHouse: undefined,
  hideCommunity: false,
  hideFloorplan: false,
  hideLot: false,
  className: undefined,
};

export default withData(
  {
    home: true,
    community: true,
    plan: true,
  },
  {
    required: {
      home: true,
    },
  },
)(HomeCard);



// WEBPACK FOOTER //
// ./src/components/HomeCard.js